module.exports = __webpack_public_path__ + "img/ic_no_photo.a3eebc7c.svg";